import { Directive, ElementRef } from '@angular/core';

declare var $: any;

@Directive({
  selector: '[appFileDesign]'
})
export class FileDesignDirective {

  constructor(el: ElementRef) {
    $(el.nativeElement).filestyle({
      'htmlIcon': '<i class="fa fa-inbox mr-5"></i>',
      'btnClass': 'btn-default',
    });
 }

}
